import { render, staticRenderFns } from "./ElderHeader.vue?vue&type=template&id=abc87d9e&scoped=true&"
import script from "./ElderHeader.vue?vue&type=script&lang=js&"
export * from "./ElderHeader.vue?vue&type=script&lang=js&"
import style0 from "./ElderHeader.vue?vue&type=style&index=0&id=abc87d9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc87d9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VBtn,VImg,VSpacer})
